/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { IScheduledJob } from '../../../core/models';

@Component({
  selector: 'fm-scheduler-balloon-section',
  templateUrl: './scheduler-balloon-section.component.html',
  styleUrls: ['./scheduler-balloon-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulerBalloonSectionComponent {
  @Input()
  public scheduledJobs: IScheduledJob[];

  @Output()
  public scheduledJobClicked = new EventEmitter<IScheduledJob>();

  public onScheduledJobClicked(scheduledJob: IScheduledJob) {
    this.scheduledJobClicked.emit(scheduledJob);
  }
}
